import React from 'react';
import Button from '@atlaskit/button';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import { PopupSelect } from '@atlaskit/select';
import type { ResolutionOption } from '../../../common/types';
import { mapOptionToResolutionOption } from '../../../common/utils';

// eslint-disable-next-line jira/import/no-parent-imports
import { ResolutionReadView } from '../../read';

type Props = {
	value: ResolutionOption | null;
	allowedOptions: ResolutionOption[];
	onChange: (option: ResolutionOption) => void;
	isOpenByDefault?: boolean;
};

export const ResolutionEditView = ({
	value = null,
	allowedOptions,
	onChange,
	isOpenByDefault = false,
}: Props) => (
	<PopupSelect
		options={allowedOptions || []}
		value={value}
		target={({ ref }) => (
			<Button
				ref={ref}
				iconAfter={<ChevronDownIcon label="open" />}
				appearance="subtle"
				testId="issue-field-resolution.ui.edit.popover.button"
				interactionName="auto-generated.issue-field-resolution.ui.edit.popover.button.button"
			>
				<ResolutionReadView
					value={value ? mapOptionToResolutionOption(value) : null}
					isLabelClickEnabled
				/>
			</Button>
		)}
		// @ts-expect-error - TS2769 - No overload matches this call.
		onChange={onChange}
		isSearchable={false}
		searchThreshold={99999}
		defaultIsOpen={isOpenByDefault}
	/>
);
